module.exports = "/content/f60ece9f3d9aa60088aed1cd7d7e17a0.png";